/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedNumber9 = createReactComponent(
  "square-rounded-number-9",
  "IconSquareRoundedNumber9",
  [
    [
      "path",
      {
        d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
        key: "svg-0"
      }
    ],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedNumber9 as default };
//# sourceMappingURL=IconSquareRoundedNumber9.js.map
